import { ClassNames } from '@emotion/react'
import styled from '@emotion/styled'
import { Transition } from '@headlessui/react'
import { ReactNode } from 'react'

import { Color, theme } from '../constants'

type CSS = (template: TemplateStringsArray, ...args: any[]) => string

const HEIGHT = 48

const EditBarClip = styled.nav({
  left: 0,
  overflow: 'hidden',
  position: 'sticky',
  right: 0,
  top: 0,
  // There's a sidebar in `@bemlo/app` with `z-index: 40`.
  zIndex: 2,
})

const EditBarElement = styled.div({
  alignItems: 'center',
  backgroundColor: Color.LIGHTER_BLUE,
  top: 0,
  boxShadow: theme.boxShadow.normal,
  display: 'flex',
  height: HEIGHT,
  left: 0,
  position: 'absolute',
  right: 0,
})

export type EditBarProps = {
  fixedPosition?: boolean
  isEditing: boolean
  marginBottom?: number
  children: ReactNode
}

export const EditBar = ({
  fixedPosition,
  children,
  isEditing,
  marginBottom = 0,
}: EditBarProps) => {
  const transition: Record<'base' | 'from' | 'to', (css: CSS) => string> = {
    base: (css) => css`
      transition: height ${theme.animation.transition}
        ${fixedPosition ? `, margin-bottom ${theme.animation.transition}` : ''};
    `,
    from: (css) => css`
      height: 0px;
      ${fixedPosition ? `margin-bottom: 0px;` : ''}
    `,
    to: (css) => css`
      height: ${HEIGHT + marginBottom}px;
      ${fixedPosition ? `margin-bottom: -${HEIGHT + marginBottom}px;` : ''}
    `,
  }

  return (
    <ClassNames>
      {({ css }) => (
        <Transition
          as={EditBarClip}
          show={isEditing}
          enter={transition.base(css)}
          leave={transition.base(css)}
          enterFrom={transition.from(css)}
          enterTo={transition.to(css)}
          leaveFrom={transition.to(css)}
          leaveTo={transition.from(css)}
        >
          <EditBarElement>{children}</EditBarElement>
        </Transition>
      )}
    </ClassNames>
  )
}
